module.exports = __webpack_public_path__ + "assets/pass_applied.18186ce5.svg";